module.exports = __webpack_public_path__ + "static/media/slide-three.6f82dfc8.webp";